__turbopack_context__.v({
  "compareAllFeaturesBtn": "Table-module-scss-module__0WJOMa__compareAllFeaturesBtn",
  "compareAllFeaturesSection": "Table-module-scss-module__0WJOMa__compareAllFeaturesSection",
  "sticky": "Table-module-scss-module__0WJOMa__sticky",
  "stuck": "Table-module-scss-module__0WJOMa__stuck",
  "table": "Table-module-scss-module__0WJOMa__table",
});
